import React, { useEffect, useState } from "react";
import { AppState } from "../../Store";
import { connect } from "react-redux";
import TelemaOrdersTable from "../../Components/TelemaOrdersTable/TelemaOrdersTable";
import { fetchWorkers } from "../../Store/Workers/actions";
import WorkersTable from "../../Components/WorkersTable/WorkersTable";
import { Worker } from "../../Models/Worker";
import { Col, Row, Space } from "antd";
import AddLabelModal from "../../Components/LabelsTable/AddLabelModal";
import CheckableTag from "antd/lib/tag/CheckableTag";
import { LabelLanguageFilter, LabelWeightFilter } from "../Labels/LabelsView";

interface OrdersProps {
  fetchWorkers: () => void;
  workers: Worker[];
}

interface RadioOption {
  label: string;
  value: number;
}

export enum WorkerFilter {
  ALL = 0,
  PACKERS = 1,
}

function WorkersView(props: OrdersProps) {
  useEffect(() => {
    props.fetchWorkers();
  }, []);

  const [filter, setFilter] = useState<WorkerFilter[]>([WorkerFilter.ALL]);

  const Filter = () => {
    const options: RadioOption[] = [
      {
        label: "Kõik",
        value: WorkerFilter.ALL,
      },
      {
        label: "Pakkijad",
        value: WorkerFilter.PACKERS,
      },
    ];

    const isChecked = (option: RadioOption) => {
      return filter.indexOf(option.value) > -1;
    };

    const handleChange = (optionValue: number, checked: boolean) => {
      const nextFilter = checked
        ? [optionValue]
        : filter.filter((t) => t !== optionValue);
      setFilter(nextFilter);
    };

    return (
      <>
        {options.map((o) => {
          var oIsChecked = isChecked(o);
          return (
            <CheckableTag
              key={o.value}
              checked={oIsChecked}
              onChange={(checked) => handleChange(o.value, checked)}
              style={{
                borderColor: oIsChecked ? "#1890ff" : "#d9d9d9",
                background: oIsChecked ? "#1890ff" : "#ffffff",
                padding: "4px 15px",
                fontSize: "14px",
                margin: 0,
                height: "32px",
              }}
            >
              {o.label}
            </CheckableTag>
          );
        })}
      </>
    );
  };

  const TableHeader = () => {
    return (
      <Row style={{ marginBottom: 10 }}>
        <Col flex="auto">
          <Space size={"large"}>
            <Filter />
          </Space>
        </Col>
        <Col></Col>
      </Row>
    );
  };

  return (
    <>
      <TableHeader />
      <WorkersTable workers={props.workers} filter={filter} />
    </>
  );
}

const mapStateToProps = (state: AppState) => ({
  // @ts-ignore
  workers: state.workers.workers.sort(
    // @ts-ignore
    (a, b) => new Date(b.nickName) - new Date(b.nickName)
  ),
});

const mapDispatchToProps = {
  fetchWorkers,
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkersView);
